<app-popover width="150px" [hidden]="!overIconData">
  @if (overIconData) {
    <div [innerText]="overIconData['text']"></div>
  }
</app-popover>
<table
  mat-table
  class="flat-table"
  [dataSource]="tableData"
  [trackBy]="trackById"
>
  @for (col of displayColumns; track col; let j = $index) {
    <ng-container [matColumnDef]="col">
      <th mat-header-cell *matHeaderCellDef [ngStyle]="columnProps[j].style">
        {{ columnProps[j].header }}
      </th>
      <td
        mat-cell
        *matCellDef="let element = $implicit; let i = index"
        [ngClass]="'cell-' + columnProps[j].type"
        [ngStyle]="hideHeaders && columnProps[j].style"
      >
        <div>
          @switch (columnProps[j].type) {
            @case (ICON_TYPE) {
              <div>
                <mat-icon
                  (mouseover)="iconOver(element[col], i)"
                  (mouseout)="iconOut()"
                >
                  {{ element[col]['icon'] }}
                </mat-icon>
              </div>
            }
            @case (CRUD_TYPE) {
              <div>
                <button
                  matTooltip="Edit"
                  mat-icon-button
                  aria-label="Edit"
                  (click)="onActionClick(element, CRUD_EDIT)"
                >
                  <mat-icon>edit_outline</mat-icon>
                </button>
                <button
                  matTooltip="Delete"
                  mat-icon-button
                  aria-label="Delete"
                  (click)="onActionClick(element, CRUD_DELETE)"
                >
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
            }
            @case (SELECT_TYPE) {
              <div class="sel text-right">
                <mat-icon>chevron_right</mat-icon>
              </div>
            }
            @default {
              <div>{{ element[col] }}</div>
            }
          }
        </div>
      </td>
    </ng-container>
  }

  <tr
    [hidden]="hideHeaders"
    mat-header-row
    *matHeaderRowDef="displayColumns"
  ></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayColumns"
    [ngClass]="{ selectable: selectableRow }"
    (click)="onClickRow(row)"
  ></tr>
</table>
